import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import UnstyledImg from "gatsby-image"
import styled, { css } from "styled-components"

export default ({ title, subtitle, fluid, titleElement }) => {
  const imageData = useStaticQuery(graphql`
    query {
      defaultFeaturedImage: file(relativePath: { eq: "slide-festival1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const TitleElement = titleElement === "h2" ? H2 : H1

  return (
    <Header hasSubtitle={subtitle ? true : false}>
      <ImgContainer>
        <Img
          fluid={
            fluid ? fluid : imageData.defaultFeaturedImage.childImageSharp.fluid
          }
        />
      </ImgContainer>
      <Inner>
        <TitleElement>{title}</TitleElement>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Inner>
    </Header>
  )
}

const Header = styled.header`
  --offset: ${({ hasSubtitle }) => (hasSubtitle ? `3.5rem` : `2.5rem`)};
  position: relative;
  margin: 0 0 calc(var(--offset) + 2rem);
`

const ImgContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
`

const Img = styled(UnstyledImg)`
  width: 100%;
  height: 100%;
`

const Inner = styled.div`
  position: relative;
  top: var(--offset);
  z-index: 2;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  flex-direction: column;
  width: calc(100% - 1rem);
  max-width: ${({ theme }) => theme.maxWidth}px;
  height: 60vh;
  margin: 0 auto;
`

const titleStyles = () => css`
  margin: 0;
  padding: 1rem 0.5rem;
  line-height: 1;
  font-size: 1.5rem;
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.main};

  @media (min-width: 23.4375em) {
    font-size: 2rem;
  }

  @media (min-width: 37.5em) {
    padding: 1rem;
    font-size: 3rem;
  }
`

const H1 = styled.h1`
  ${titleStyles()}
`
const H2 = styled.h2`
  ${titleStyles()}
`

const Subtitle = styled.p`
  margin: 0;
  padding: 0.5rem 1rem;
  line-height: 1;
  font-size: 1.25rem;
  background: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.main};
`
